import NoSidebarContainer from "../../../Components/Blog/NoSidebar";

const NoSidebar = () => {
  return <NoSidebarContainer />;
};

export default NoSidebar;
